<template>
  <div class="signage-system">
    <!-- 主要板块选择 -->
    <div class="main-sections">
      <div 
        v-for="(section, index) in mainSections" 
        :key="index"
        class="main-section"
        :style="{ '--section-color': section.color }"
        @click="selectMainSection(index)"
        :class="{ 'active': selectedMainSection === index }"
      >
        <div class="section-icon">
          <i :class="section.icon"></i>
        </div>
        <div class="section-title">{{ section.title }}</div>
        <div class="section-subtitle">{{ section.subtitle }}</div>
        <div class="section-count" v-if="section.items">
          {{ section.items.length }}项
        </div>
      </div>
    </div>

    <!-- 子版块选择（仅在综合服务信息牌优化时显示） -->
    <div class="sub-sections" v-if="selectedMainSection === 0">
      <div 
        v-for="(subItem, index) in mainSections[0].items" 
        :key="index"
        class="sub-section"
        :style="{ '--sub-color': subItem.color }"
        @click="selectSubSection(index)"
        :class="{ 'active': selectedSubSection === index }"
      >
        <div class="sub-icon">
          <i :class="subItem.icon"></i>
        </div>
        <div class="sub-name">{{ subItem.name }}</div>
        <div class="sub-type">{{ subItem.type }}</div>
      </div>
    </div>

    <!-- 详细信息展示区域 -->
    <div class="signage-details" v-if="getCurrentItem()">
      <div class="detail-header">
        <h4>{{ getCurrentItem()?.name }}</h4>
        <div class="optimization-badge" :style="{ '--badge-color': getCurrentItem()?.badgeColor }">
          {{ getCurrentItem()?.status }}
        </div>
      </div>

      <div class="description">
        <p>{{ getCurrentItem()?.description }}</p>
      </div>

      <!-- 图片展示区域 -->
      
      <!-- "因地制宜分类设置"的图片展示 -->
      <div class="image-gallery" v-if="getCurrentItem()?.name === '因地制宜分类设置'">
        <h5>三种设置方式实景展示</h5>
        <div class="image-grid">
          <div class="image-item">
            <div class="image-container">
              <img src="/包柱式.jpg" alt="包柱式标识牌" />
            </div>
            <div class="image-caption">
              <h6>包柱式</h6>
              <p>利用车站柱体，360度信息展示，充分利用空间</p>
            </div>
          </div>
          <div class="image-item">
            <div class="image-container">
              <img src="/上墙式.jpg" alt="上墙式标识牌" />
            </div>
            <div class="image-caption">
              <h6>上墙式</h6>
              <p>墙面安装，节省通道空间，便于乘客查看</p>
            </div>
          </div>
          <div class="image-item">
            <div class="image-container">
              <img src="/立牌式.jpg" alt="立牌式标识牌" />
            </div>
            <div class="image-caption">
              <h6>立牌式</h6>
              <p>独立设置，位置灵活可调，适应不同环境</p>
            </div>
          </div>
        </div>
      </div>

      <!-- "下沉式广场精准引导"的图片展示 -->
      <div class="image-gallery" v-if="getCurrentItem()?.name === '下沉式广场精准引导'">
        <h5>下沉式广场信息牌设置示例</h5>
        <div class="image-grid two-column">
          <div class="image-item">
            <div class="image-container">
              <img src="/综合服务信息牌（站内）.jpg" alt="综合服务信息牌（站内）" />
            </div>
            <div class="image-caption">
              <h6>综合服务信息牌（站内）</h6>
              <p>站内设置的综合信息牌，提供全面的服务指引</p>
            </div>
          </div>
          <div class="image-item">
            <div class="image-container">
              <img src="/综合服务信息牌（地面）.gif" alt="综合服务信息牌（地面）" />
            </div>
            <div class="image-caption">
              <h6>综合服务信息牌（地面）</h6>
              <p>地面设置的信息牌，通过导向箭头明确指引进站路径</p>
            </div>
          </div>
        </div>
      </div>

      <!-- "服务设施图示指引"的图片展示 -->
      <div class="image-gallery" v-if="getCurrentItem()?.name === '服务设施图示指引'">
        <h5>街区图与路线标注示例</h5>
        <div class="image-grid single-column">
          <div class="image-item">
            <div class="image-container">
              <img src="/街区图与路线标注.jpg" alt="街区图与路线标注" />
            </div>
            <div class="image-caption">
              <h6>街区图与路线标注</h6>
              <p>借助街区图与路线标注，清晰指引无障碍设施具体位置</p>
            </div>
          </div>
        </div>
      </div>

      <!-- "服务设施方位指引"的图片展示 -->
      <div class="image-gallery" v-if="getCurrentItem()?.name === '服务设施方位指引'">
        <h5>服务设施指引示例</h5>
        <div class="image-grid single-column">
          <div class="image-item">
            <div class="image-container">
              <img src="/服务设施指引图.jpg" alt="服务设施指引图" />
            </div>
            <div class="image-caption">
              <h6>服务设施指引图</h6>
              <p>使用箭头指引方位，增加距离指示，标注卫生间位置</p>
            </div>
          </div>
        </div>
      </div>

      <!-- ""敞开式"出入口导向优化"的图片展示 -->
      <div class="image-gallery" v-if="getCurrentItem()?.name === '&quot;敞开式&quot;出入口导向优化'">
        <h5>敞开式出入口优化示例</h5>
        <div class="image-grid single-column">
          <div class="image-item">
            <div class="image-container">
              <img src="/敞开式出入口导向优化.jpg" alt="敞开式出入口导向优化" />
            </div>
            <div class="image-caption">
              <h6>"敞开式"出入口导向优化</h6>
              <p>针对不易寻找的敞开式出入口进行导向优化，提升识别度</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'

interface Application {
  title: string
  description: string
}

interface SignageItem {
  name: string
  type: string
  icon: string
  color: string
  status: string
  description: string
  features: string[]
  application?: Application[]
  badgeColor?: string
}

interface MainSection {
  title: string
  subtitle: string
  icon: string
  color: string
  items?: SignageItem[]
  // 对于单一项目（如敞开式出入口），直接继承SignageItem的属性
  name?: string
  type?: string
  status?: string
  description?: string
  features?: string[]
  application?: Application[]
  badgeColor?: string
}

const selectedMainSection = ref(0)
const selectedSubSection = ref(0)

// 主要板块数据
const mainSections: MainSection[] = [
  {
    title: '综合服务信息牌优化',
    subtitle: '系统性改进方案',
    icon: 'fas fa-info-circle',
    color: '#0085C3',
    items: [
      {
        name: '因地制宜分类设置',
        type: '包柱、上墙、立牌',
        icon: 'fas fa-cogs',
        color: '#0085C3',
        status: '系统优化',
        badgeColor: '#dcfce7',
        description: '在设置上，充分考量乘客的视线范围与行走路径，精准设定离地高度和安装位置，结合不同车站出入口特性，采用包柱、上墙、立牌三种安装方式，确保信息展示的全面性和可视性，实现服务信息高效传递。',
        features: [
          '充分考量乘客视线范围与行走路径',
          '精准设定离地高度和安装位置',
          '结合出入口特性选择安装方式',
          '确保信息展示全面性和可视性'
        ],
        application: [
          {
            title: '包柱式',
            description: '利用车站柱体，360度信息展示'
          },
          {
            title: '上墙式', 
            description: '墙面安装，节省通道空间'
          },
          {
            title: '立牌式',
            description: '独立设置，位置灵活可调'
          }
        ]
      },
      {
        name: '下沉式广场精准引导',
        type: '导向箭头指引',
        icon: 'fas fa-arrow-down',
        color: '#ef4444',
        status: '针对性改进',
        badgeColor: '#fef3c7',
        description: '部分下沉式广场的站点入口不明显，乘客不易发现。对这类出入口，在地面设置综合服务信息牌，通过导向箭头更明确地指引乘客进站。',
        features: [
          '解决下沉式广场入口不明显问题',
          '地面设置综合服务信息牌',
          '导向箭头明确指引进站路径',
          '提升乘客发现和识别能力'
        ],
        application: [
          {
            title: '人民广场等大型换乘站',
            description: '复杂地下空间的入口引导'
          },
          {
            title: '商业区下沉广场',
            description: '与商业设施融合的地铁入口'
          }
        ]
      },
      {
        name: '服务设施图示指引',
        type: '街区图与路线标注',
        icon: 'fas fa-map-marked-alt',
        color: '#10b981',
        status: '功能增强',
        badgeColor: '#d1fae5',
        description: '对于离无障碍电梯较远的出入口，综合服务信息牌借助街区图与路线标注，清晰指引无障碍设施具体位置。',
        features: [
          '街区图清晰标注设施位置',
          '路线标注指引最优路径',
          '专门针对离设施较远的出入口',
          '提升无障碍出行便利性'
        ],
        application: [
          {
            title: '大型车站',
            description: '复杂结构中的设施导航'
          },
          {
            title: '多出入口站点',
            description: '不同出入口的设施指引'
          }
        ]
      },
      {
        name: '服务设施方位指引',
        type: '箭头+距离+位置标注',
        icon: 'fas fa-compass',
        color: '#f59e0b',
        status: '全面升级',
        badgeColor: '#dbeafe',
        description: '对临近无障碍电梯的出入口，直接使用箭头指引方位，并增加距离指示；新增车站卫生间位置指引，标注位于费区内或费区外，便于乘客选择；设置寄存柜的车站新增行李寄存指引。',
        features: [
          '箭头指引方位+距离指示',
          '卫生间费区内外位置标注',
          '新增行李寄存柜指引',
          '便于乘客提前选择和规划'
        ],
        application: [
          {
            title: '无障碍电梯指引',
            description: '临近出入口的精确方位'
          },
          {
            title: '卫生间位置标注',
            description: '费区内外选择便民服务'
          },
          {
            title: '寄存柜服务',
            description: '行李寄存便民指引'
          }
        ]
      }
    ]
  },
  {
    title: '"敞开式"出入口导向优化',
    subtitle: '7处试点完成',
    icon: 'fas fa-door-open',
    color: '#8b5cf6',
    name: '"敞开式"出入口导向优化',
    type: '试点改进项目',
    status: '7处试点完成',
    badgeColor: '#f3e8ff',
    description: '对于乘客不易寻找的"敞开式"出入口，完成7处导向优化试点工作。',
    features: [
      '专门针对敞开式出入口',
      '解决乘客查找困难问题',
      '7处试点示范效果',
      '提升出入口识别度'
    ],
    application: [
      {
        title: '商业综合体内',
        description: '与商场入口融合的地铁站'
      },
      {
        title: '开放式街区',
        description: '无明显界限的地铁出入口'
      }
    ]
  }
]

// 获取当前显示的项目
const getCurrentItem = (): SignageItem | null => {
  const currentMainSection = mainSections[selectedMainSection.value]
  
  if (selectedMainSection.value === 0) {
    // 综合服务信息牌优化 - 显示选中的子项
    return currentMainSection.items?.[selectedSubSection.value] || null
  } else {
    // 敞开式出入口导向优化 - 直接显示主项
    return {
      name: currentMainSection.name || '',
      type: currentMainSection.type || '',
      icon: currentMainSection.icon,
      color: currentMainSection.color,
      status: currentMainSection.status || '',
      description: currentMainSection.description || '',
      features: currentMainSection.features || [],
      application: currentMainSection.application,
      badgeColor: currentMainSection.badgeColor
    }
  }
}

// 选择主要板块
const selectMainSection = (index: number) => {
  selectedMainSection.value = index
  selectedSubSection.value = 0  // 重置子项选择
}

// 选择子版块
const selectSubSection = (index: number) => {
  selectedSubSection.value = index
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+SC:wght@400;500;600;700&display=swap');

.signage-system {
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #f8fafc, #e2e8f0);
  border-radius: 12px;
  overflow: hidden;
  font-family: 'Noto Serif SC', serif;
}

/* 主要板块选择区域 */
.main-sections {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 20px;
  background: white;
  border-bottom: 3px solid #e2e8f0;
}

.main-section {
  padding: 24px 20px;
  border-radius: 12px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  text-align: center;
  position: relative;
}

.main-section:hover {
  border-color: var(--section-color);
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.main-section.active {
  border-color: var(--section-color);
  background: white;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.section-icon {
  font-size: 36px;
  color: var(--section-color);
  margin-bottom: 12px;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 6px;
  display: block;
  font-family: 'Noto Serif SC', serif;
  text-align: center;
}

.section-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 8px;
  text-align: center;
}

.section-count {
  position: absolute;
  top: 12px;
  right: 12px;
  background: var(--section-color);
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

/* 子版块选择区域 */
.sub-sections {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  padding: 16px 20px;
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.sub-section {
  padding: 16px 12px;
  border-radius: 8px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
  text-align: center;
}

.sub-section:hover {
  border-color: var(--sub-color);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.sub-section.active {
  border-color: var(--sub-color);
  background: white;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.sub-icon {
  font-size: 20px;
  color: var(--sub-color);
  margin-bottom: 8px;
}

.sub-name {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
  line-height: 1.3;
}

.sub-type {
  font-size: 11px;
  color: #6b7280;
  line-height: 1.2;
}

/* 详细信息区域 */
.signage-details {
  padding: 24px;
  background: white;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #0085C3;
}

.detail-header h4 {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  font-family: 'Noto Serif SC', serif;
}

.optimization-badge {
  padding: 6px 12px;
  background: var(--badge-color, #dcfce7);
  color: #166534;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.description {
  margin-bottom: 24px;
}

.description p {
  color: #6b7280;
  line-height: 1.6;
  margin: 0;
  font-size: 14px;
  font-family: 'Noto Serif SC', serif;
}

/* 图片展示区域 */
.image-gallery {
  margin-bottom: 24px;
}

.image-gallery h5 {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  font-family: 'Noto Serif SC', serif;
}

.image-gallery h5::before {
  content: '';
  width: 4px;
  height: 16px;
  background: #0085C3;
  margin-right: 8px;
  border-radius: 2px;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

/* 两列布局 */
.image-grid.two-column {
  grid-template-columns: repeat(2, 1fr);
}

/* 单列布局 */
.image-grid.single-column {
  grid-template-columns: 1fr;
  max-width: 600px;
  margin: 0 auto;
}

.image-item {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.image-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  border-color: #0085C3;
}

.image-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.image-container img {
  width: 100%;
  height: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
  display: block;
}

.image-item:hover .image-container img {
  transform: scale(1.05);
}

.image-caption {
  padding: 16px;
}

.image-caption h6 {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 8px 0;
  font-family: 'Noto Serif SC', serif;
}

.image-caption p {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
  margin: 0;
  font-family: 'Noto Serif SC', serif;
}



/* 响应式设计 */
@media (max-width: 768px) {
  .main-sections {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 16px;
  }
  
  .main-section {
    padding: 20px 16px;
  }
  
  .section-title {
    font-size: 16px;
  }
  
  .sub-sections {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 8px;
    padding: 12px 16px;
  }
  
  .sub-section {
    padding: 12px 8px;
  }
  
  .sub-name {
    font-size: 12px;
  }
  
  .signage-details {
    padding: 20px;
  }
  
  .image-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .image-grid.two-column {
    grid-template-columns: 1fr;
  }
  
  .image-grid.single-column {
    max-width: 100%;
  }
  
  .image-caption {
    padding: 12px;
  }
  
  .image-caption h6 {
    font-size: 14px;
  }
  
  .image-caption p {
    font-size: 13px;
  }
}
</style>